import extend from '@/utils/vuex-extend';
import { dialog } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import {fetchGoodsMainImages} from "@/api/oms/goods";

export default extend(dialog, {
	namespaced: true,
	state: {
		goodsId: 0,
		skuItem: {},
		imgList: []
	},
	actions: {
		async afterOpenDialog({ dispatch, commit, state }, payload) {
			const { goodsId } = state;
			await wait(dispatch, 'pcm.auto-purchase.sku-img-upload', async function() {
				console.log('opened', goodsId)
				const response = await fetchGoodsMainImages({goodsId})
				if (response.data) {
					commit('save', {
						imgList: response.data
					})
				}
			})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/pcm/auto-purchase/sku-img-upload.js